import { useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { notifyError, notifyPending } from "../../../../utils/notify";
import Form from "../../../../components/Base/Form/Form";
import Fieldset from "../../../../components/Base/Fieldset/Fieldset";
import FileInput from "../../../../components/Base/FileInput/FileInput";
import ButtonBar from "../../../../components/Base/ButtonBar/ButtonBar";
import Button from "../../../../components/Base/Button/Button";
import { useFetchCargueMasivo } from "../../../TrxParams/hooks/fetchCargueMasivo";

const URL_UPLOAD = `${process.env.REACT_APP_URL_BANCO_AGRARIO}/banco-agrario/electronic-tally/upload-support`;

const UploadElectronicTally = () => {
  const { state } = useLocation();
  const id = state?.id;
  const navigate = useNavigate();

  const [file, setFile] = useState<File | undefined>();
  const [loadingRequestUploadSupport, requestUploadSupport] = useFetchCargueMasivo(
    URL_UPLOAD,
    "",
    "Carga Comprobante",
    false,
    true
  );

  const uploadSupport = useCallback(
    (e) => {
      e.preventDefault();

      if (!file) {
        return notifyError("Debes seleccionar un archivo para subir.");
      }

      const validTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        return notifyError("Solo se permiten imágenes PNG, JPG o JPEG.");
      }

      if (!id) {
        return notifyError("ID no definido.");
      }

      const formData = new FormData();
      formData.append("id", id);
      formData.append("file", file as Blob);

      const dataAdditional = { id };

      if (typeof requestUploadSupport === "function") {
        notifyPending(
          requestUploadSupport(formData, dataAdditional),
          {
            render: () => "Subiendo archivo...",
          },
          {
            render: () => {
              navigate("/GestionTransaccional/punteo-electronico/lista");
              return "Cargue de Soporte exitoso";
            },
          },
          {
            render: ({ data: error }) => {
              if (error?.optionalObject?.archivoErrores instanceof Blob) {
                const urlFile = URL.createObjectURL(error.optionalObject.archivoErrores);
                const a = document.createElement("a");
                a.href = urlFile;

                const actualDate = new Intl.DateTimeFormat("es-ES", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  second: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: false,
                }).format(new Date());

                a.download = `Errores_cargue_comprobante_${actualDate}`.replace(",", "");
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              }
              navigate(-1);
              return error?.message ?? "Error al subir el archivo.";
            },
          }
        );
      }
    },
    [file, id, requestUploadSupport, navigate]
  );
  return (
    <Form formDir="col" onSubmit={uploadSupport}>
      <Fieldset legend="Comprobante Punteo Electrónico" className="lg:col-span-2">
        <h1 className="text-2xl text-center mb-10 mt-5">Cargar comprobante</h1>

        {!file && (
          <FileInput
            label="Adjuntar comprobante"
            onGetFile={(files: File[]) => setFile(files[0])}
            accept=".png,.jpg,.jpeg"
            allowDrop={true}
          />
        )}

        {file && (
          <>
            <div className="grid grid-cols-8 gap-4 justify-items-center mt-5">
              <span className="text-3xl text-primary col-span-1 bi bi-file-earmark-plus-fill" />
              <p className="col-span-6 self-center">{file.name}</p>
              <span
                className="text-3xl text-red-700 col-span-1 bi bi-trash-fill cursor-pointer"
                onClick={loadingRequestUploadSupport ? () => {} : () => setFile(undefined)}
              />
            </div>
          </>
        )}

        <ButtonBar className="mt-5">
          <Button type="submit" disabled={loadingRequestUploadSupport}>
            Finalizar
          </Button>
        </ButtonBar>
      </Fieldset>
    </Form>
  );
};

export default UploadElectronicTally;
